(function () {
  var labels = {
    addToCart: 'Add to Bag',
    soldOut: 'Sold Out',
    adding: 'Adding…',
    added: 'Added to Bag'
  };

  function initSection(section) {
    if (!section || section.dataset.fitnLookbookInit) return;
    section.dataset.fitnLookbookInit = 'true';

    var sectionId = section.getAttribute('data-fitn-lookbook-section');
    var lightbox = document.getElementById('fitn-lookbook-lightbox-' + sectionId);
    if (!lightbox) return;

    if (lightbox.parentElement !== document.body) {
      document.body.appendChild(lightbox);
    }

    var shots = Array.prototype.slice.call(section.querySelectorAll('[data-fitn-lookbook-shot]'));
    if (!shots.length) return;

    var mediaEl = lightbox.querySelector('[data-fitn-lookbook-media]');
    var shopEl = lightbox.querySelector('[data-fitn-lookbook-shop]');
    var panelFrame = lightbox.querySelector('[data-fitn-lookbook-panel-frame]');
    var currentIndex = 0;
    var previousFocus = null;

    function panelTemplate(shot) {
      var template = shot.querySelector('template');
      return template ? template.content.firstElementChild : null;
    }

    function showShot(index) {
      if (!shots.length || !mediaEl || !shopEl) return;

      currentIndex = (index + shots.length) % shots.length;
      var shot = shots[currentIndex];
      var panel = panelTemplate(shot);
      if (!panel) return;

      var mediaSource = panel.querySelector('[data-fitn-lookbook-panel-media]');
      var shopSource = panel.querySelector('[data-fitn-lookbook-panel-shop]');

      mediaEl.innerHTML = '';
      shopEl.innerHTML = '';

      if (mediaSource) mediaEl.appendChild(mediaSource.cloneNode(true));
      if (shopSource) shopEl.appendChild(shopSource.cloneNode(true));

      if (panelFrame) {
        panelFrame.classList.toggle('fitn-lookbook-lightbox__panel--no-shop', !shopSource);
      }

      var solo = shots.length <= 1;
      var visual = lightbox.querySelector('[data-fitn-lookbook-visual]');
      if (visual) visual.classList.toggle('fitn-lookbook-lightbox__visual--solo', solo);

      var prevBtn = lightbox.querySelector('[data-fitn-lookbook-prev]');
      var nextBtn = lightbox.querySelector('[data-fitn-lookbook-next]');
      if (prevBtn) {
        prevBtn.hidden = solo;
        prevBtn.disabled = solo;
      }
      if (nextBtn) {
        nextBtn.hidden = solo;
        nextBtn.disabled = solo;
      }
    }

    function openLightbox(index) {
      previousFocus = document.activeElement;
      showShot(index);
      lightbox.hidden = false;
      lightbox.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('fitn-lookbook-lightbox-open');

      var dialog = lightbox.querySelector('[data-fitn-lookbook-dialog]');
      if (dialog) dialog.scrollTop = 0;

      var closeBtn = lightbox.querySelector('.fitn-lookbook-lightbox__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeLightbox() {
      lightbox.hidden = true;
      lightbox.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('fitn-lookbook-lightbox-open');
      if (mediaEl) mediaEl.innerHTML = '';
      if (shopEl) shopEl.innerHTML = '';
      if (previousFocus && typeof previousFocus.focus === 'function') {
        previousFocus.focus();
      }
      previousFocus = null;
    }

    function onOpenClick(event) {
      var button = event.target.closest('[data-fitn-lookbook-open]');
      if (!button || button.disabled) return;

      var shot = button.closest('[data-fitn-lookbook-shot]');
      if (!shot || !section.contains(shot)) return;

      event.preventDefault();
      var index = shots.indexOf(shot);
      if (index < 0) return;
      openLightbox(index);
    }

    function onCloseClick(event) {
      if (event.target.closest('[data-fitn-lookbook-close]')) {
        event.preventDefault();
        closeLightbox();
      }
    }

    lightbox.querySelectorAll('[data-fitn-lookbook-close]').forEach(function (closeEl) {
      closeEl.addEventListener('click', onCloseClick);
    });

    function onNavClick(event) {
      if (event.target.closest('[data-fitn-lookbook-prev]')) {
        event.preventDefault();
        showShot(currentIndex - 1);
      }
      if (event.target.closest('[data-fitn-lookbook-next]')) {
        event.preventDefault();
        showShot(currentIndex + 1);
      }
    }

    function onKeydown(event) {
      if (lightbox.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        closeLightbox();
        return;
      }

      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        showShot(currentIndex - 1);
      }

      if (event.key === 'ArrowRight') {
        event.preventDefault();
        showShot(currentIndex + 1);
      }
    }

    function onSubmit(event) {
      var form = event.target.closest('[data-fitn-lookbook-atc-form]');
      if (!form || !lightbox.contains(form)) return;

      event.preventDefault();

      var submitBtn = form.querySelector('[data-fitn-lookbook-atc-submit]');
      var select = form.querySelector('[data-fitn-lookbook-atc-select]');
      var hiddenId = form.querySelector('input[name="id"][type="hidden"]');
      var variantId = select ? select.value : hiddenId ? hiddenId.value : '';

      if (!variantId) {
        if (select) select.focus();
        return;
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = labels.adding;
      }

      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          return fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart.js');
        })
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          if (window.FitnWishlist) window.FitnWishlist.applyCart(cart);
          if (submitBtn) {
            submitBtn.textContent = labels.added;
            window.setTimeout(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = labels.addToCart;
            }, 1400);
          }
        })
        .catch(function () {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = labels.addToCart;
          }
        });
    }

    section.addEventListener('click', onOpenClick);
    lightbox.addEventListener('click', onNavClick);
    document.addEventListener('keydown', onKeydown);
    lightbox.addEventListener('submit', onSubmit);
  }

  function init() {
    document.querySelectorAll('[data-fitn-lookbook-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-fitn-lookbook-section]') || event.target;
    if (section && section.matches('[data-fitn-lookbook-section]')) {
      initSection(section);
    }
  });
})();
